module.exports = __webpack_public_path__ + "static/media/resume.f0b59f03.png";